import React from 'react';
import { Switch, Route } from 'react-router-dom';

import { useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min';
import PageNotFound from 'components/PageNotFound/PageNotFound';
import AutomationList from './AutomationList/AutomationList';
import WorkflowBuilder from './WorkflowBuilder/WorkflowBuilder';
import SettingsLayout from 'modules/settings/SettingsLayout/SettingsLayout';
import ListAutomationErrorLogWrapper from 'modules/settings/workflow_automation/components/ListAutomationErrorLog/ListAutomationErrorLog';

const AutomationRouter = () => {
  const { path } = useRouteMatch();

  const routeConfigs = [
    {
      path: `${path}`,
      component: AutomationList,
    },
    {
      path: `${path}/edit/:automationRuleId?`,
      component: WorkflowBuilder,
    },
    {
      path: `${path}/add`,
      component: WorkflowBuilder,
    },
    {
      path: `${path}/error-logs/:automationErrorLogParentId`,
      component: ListAutomationErrorLogWrapper,
    },
    {
      path: '*',
      component: PageNotFound,
    },
  ];

  return (
    <Switch>
      {routeConfigs?.map((config) => (
        <Route key={config?.path} exact path={config?.path} component={config?.component} />
      ))}
    </Switch>
  );
};

const AutomationSettingsWrapper = () => {
  return (
    <SettingsLayout>
      <AutomationRouter />
    </SettingsLayout>
  );
};

export default AutomationSettingsWrapper;
